<template>
  <div>
    <header-status />
    <v-container fluid fill-height>
      <v-layout v-if="!loading" align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-card-text>
              <v-form v-model="valid">
                <v-autocomplete
                  v-model="objForm.country"
                  :items="countrys"
                  label="País"
                  required
                  :rules="[v => !!v || 'País é obrigatório!']"
                ></v-autocomplete>
                <v-text-field
                  label="Nome Completo"
                  type="text"
                  v-model="objForm.name"
                  :rules="[v => !!v || 'Nome é obrigatório!']"
                  required
                />
                <v-text-field
                  name="email"
                  label="E-Mail"
                  type="text"
                  v-model="objForm.email"
                  :rules="[v => !!v || 'E-Mail é obrigatório!']"
                  disabled
                  required
                />
                <v-text-field
                  name="phone"
                  v-if="objForm.country == 'BR'"
                  label="Celular"
                  type="text"
                  v-model="objForm.phone"
                  v-mask="'(##) ##### ####'"
                  :rules="[v => {
                  if(!v || v.length < 15)
                    return 'Celular inválido!'
                  else return false;
                }]"
                  required
                />
                <v-text-field
                  name="phone2"
                  v-else
                  label="Celular "
                  type="text"
                  v-model="objForm.phone"
                  :rules="[v => !!v || 'Celular é obrigatório!']"
                  required
                />
                <div v-if="objForm.country == 'BR'">
                  <v-text-field
                    name="cpf"
                    label="CPF"
                    type="text"
                    v-model="objForm.cpf"
                    v-mask="'###.###.###-##'"
                    :rules="[v => {
                    return checkCPF(v) ?  false : 'CPF Inválido!'
                  }]"
                    required
                  />
                  <v-text-field
                    label="Data de Nascimento"
                    type="date"
                    v-model="objForm.birth"
                    :rules="[v => !!v || 'Data de Nascimento é obrigatório!']"
                    required
                  />
                  <v-text-field
                    v-mask="'###.##-###'"
                    label="Cep"
                    type="text"
                    v-model="objForm.zipcode"
                    :rules="[v => !!v || 'Cep é obrigatório!']"
                    required
                  />
                  <v-text-field
                    label="Rua"
                    type="text"
                    v-model="objForm.street"
                    :rules="[v => !!v || 'Rua é obrigatório!']"
                    required
                  />
                  <v-text-field
                    label="Número"
                    type="text"
                    v-model="objForm.number"
                    :rules="[v => !!v || 'Número é obrigatório!']"
                    required
                  />
                  <v-text-field label="Complemento" type="text" v-model="objForm.complement" />

                  <v-text-field
                    label="Bairro"
                    type="text"
                    v-model="objForm.district"
                    :rules="[v => !!v || 'Bairro é obrigatório!']"
                    required
                  />
                  <v-text-field
                    label="Cidade"
                    type="text"
                    v-model="objForm.city"
                    :rules="[v => !!v || 'Cidade é obrigatório!']"
                    required
                  />
                  <v-text-field
                    label="Estado"
                    type="text"
                    v-model="objForm.state"
                    :rules="[v => !!v || 'Estado é obrigatório!']"
                    required
                  />
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" :disabled="!valid" @click.native="save">SALVAR</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <dialog-loader :active="loading"></dialog-loader>
    </v-container>
  </div>
</template>

<script>
import { authService } from "../plugins/firebase";
import { COUNTRYS } from "../countrys";
export default {
  data: () => ({
    loading: true,
    valid: false,
    objForm: {
      country: "BR",
      birth: null,
      name: null,
      phone: null,
      email: null,
      cpf: null,
      zipcode: null,
      street: null,
      number: null,
      district: null,
      complement: null,
      city: null,
      state: null
    },
    countrys: []
  }),
  created() {
    this.getRemoteData();
  },
  watch: {
    "objForm.zipcode": {
      handler(cep) {
        if (!cep) return;
        console.log("objForm.zipcode", cep);
        cep = cep.replace(/[^0-9]/g, "");
        const validacep = /^[0-9]{8}$/;
        if (validacep.test(cep)) {
          console.log("validacep true", cep);
          this.$http
            .get(`https://viacep.com.br/ws/${cep}/json`)
            .then(response => response.data)
            .then(rs => {
              console.log("objForm.zipcode resp", rs);
              this.objForm.street = rs.logradouro;
              this.objForm.district = rs.bairro;
              this.objForm.city = rs.localidade;
              this.objForm.state = rs.uf;
            });
        } else {
          console.log("validacep false", cep);
        }
      },
      deep: true
    }
  },
  methods: {
    async getRemoteData() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };

      this.getCountrys();
      await this.getUser(config);
      this.loading = false;
    },
    getUser(config) {
      return this.$http
        .get(
          this.$SERVE +
            "/students/me?device_id=" +
            DeviceUUID.get() +
            "&device_name=" +
            DeviceUUID.parse().browser +
            "&platform=web",
          config
        )
        .then(response => {
          USER = response.data;
          this.user = USER;
          this.objForm.country = USER.country || "BR";
          this.objForm.name = USER.name;
          this.objForm.email = USER.email;
          this.objForm.phone = USER.phone;
          this.objForm.cpf = USER.cpf;
          this.objForm.number = USER.number;
          this.objForm.zipcode = USER.zipcode;
          this.objForm.street = USER.street;
          this.objForm.district = USER.district;
          this.objForm.complement = USER.complement;
          this.objForm.city = USER.city;
          this.objForm.state = USER.state;
          this.objForm.birth = USER.birth;
        });
    },
    getCountrys() {
      //this.objForm.country = "BR";
      COUNTRYS["country_codes"].forEach(o => {
        this.countrys.push({
          text: o.country_name,
          value: o.country_code
        });
      });
    },
    async save() {
      this.loading = true;
      if (this.objForm.country == "BR") {
        this.objForm.cpf = this.objForm.cpf.replace(/[^0-9]/g, "");
        this.objForm.zipcode = this.objForm.zipcode.replace(/[^0-9]/g, "");
      }

      const _cou = COUNTRYS["country_codes"].find(
        o => o["country_code"] == this.objForm.country
      );

      this.objForm.phone = this.objForm.phone.replace(/[^0-9]/g, "");
      this.objForm.country_phone = _cou.dialling_code + this.objForm.phone;

      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      this.$http
        .post(this.$SERVE + "/students/update", this.objForm, config)
        .then(response => response.data)
        .then(json => {
          this.loading = false;
          alert("Dados atualizados com sucesso!");
          window.location.href = "/home";
        })
        .catch(error => {
          this.loading = false;
          if (error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          } else {
            alert("Ocorreu uma falha, tente novamente!");
          }
        });
    },
    checkCPF(strCPF) {
      if (!strCPF) return false;
      strCPF = strCPF.replace(/[^0-9]/g, "");
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;
      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;
      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11))) return false;
      return true;
    }
  }
};
</script>

<style>
</style>
